import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Pagination from './../../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import BookingService from './../../../../services/cargobooking.service';
import Util from './../../../../../shared/util/util';
import CONSTANT from './../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import apiUrl from '../../../../../../constants'
import CreateCustomer from './abfrlcreatecustomer/index.vue'

export default {
  name: 'abfrlcustomerdetails',
  components: {
    VueElementLoading,
    Pagination,
    DatePicker,
    CustomExpandableTable,
    Treeselect,
    CreateCustomer
  },
  data: function() {
    return {
      tableColumn:['Customer Name','City','Consignee Code','ZipCode','State','Channel','Address','Created Date','Action'],
      tableItems:[],
      isLoading:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      Status:null,
      showCreateCustomer:false,
      customerName:'',
      consigneeCode:'',
      pincode:'',
      city:'',
      state:'',
      parentData:{},
    }
  },
  async mounted() {
    this.isLoading = true;
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    await this.getabfrlprocesslogs();
    this.isLoading = false;
 },
  methods:{
  onPageChange(page) {
    this.currentPage = page;
    this.offset = (page - 1) * this.pageLimit
    this.getabfrlprocesslogs();
  },
  searchFilter(){
    this.currentPage = 1;
    this.offset = 0;
    this.getabfrlprocesslogs();
  },
  resetSearch(){
    this.customerName='';
    this.consigneeCode='';
    this.pincode='';
    this.city='';
    this.state='';
    this.getabfrlprocesslogs();
  },
  async getabfrlprocesslogs(){
    try {
      this.isLoading = true;
      let inputPayload = {
        "offset": this.offset,
        "limit": this.pageLimit,
      }
      if(this.customerName){
        inputPayload.customername = this.customerName;
      }
      if(this.consigneeCode){
        inputPayload.consigneecode = this.consigneeCode;
      }
      if(this.pincode){
        inputPayload.pincode = this.pincode;
      }
      if(this.city){
        inputPayload.city = this.city;
      }
      if(this.state){
        inputPayload.state = this.state;
      }
      let result = await BookingService.GetAbfrlCustomerData(inputPayload)
      this.tableArr = result.data.data.rows;
      this.totalCount = result.data.data.count;
      if(this.totalCount>0){
        this.tableItems = result.data.data.rows.map((el)=>{
          return {
            'id': el.id,
            'Customer Name': el.customername,
            'City': el.city,
            'Consignee Code': el.consigneecode1,
            'ZipCode': el.zipcode,
            'State': el.state,
            'Channel': el.channel2,
            'Address': el.address,
            'Created Date': Util.displayDateTimeFormat(el.createddate),
          }
        })
      }else{
        this.tableItems = [];
      }
      if (this.totalCount < this.pageLimit) {
        this.totalPage = 1
      } else {
        this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
      }
      this.isLoading = false;
      }
      catch(err){
      console.log(err);
      this.isLoading = false;
    }
  },
  createCustomer(){
    this.parentData={
      action:'create'
    }
    this.showCreateCustomer = true;
  },
  getCustomTableEvent(event){
    this.parentData={
      id:event.id,
      action:'edit'
    }
    this.showCreateCustomer = true;
  },
 async callParent(){
    this.isLoading = true
    this.showCreateCustomer = false;
    await this.getabfrlprocesslogs()
    this.isLoading = false
  }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/abfrlLogs/abfrlcustomerdetails/abfrlCustomerDetails.component.js